<template>
  <div class="">
    <v-main>
      <template>
        <div class="text-center">
          <v-dialog v-model="dialog" width="500">
            <v-card class="">
              <v-card-text>
                <div
                  class="d-flex flex-row justify-center align-center"
                  style="width: 100%; height: 100%"
                >
                  <audio
                    v-if="release.wav_fileId && release.filename"
                    :id="'play' + release.wav_fileId.toString()"
                    :ref="'play' + release.wav_fileId.toString()"
                    :src="'https://news.renopd.com/wav/' + release.filename"
                    controls
                  ></audio>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="white--text ml-2 mt-2"
                  text
                  @click="dialog = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <v-container class="" id="home-container">
        <div id="hero" class="background-container-img">
          <div
            id="title_layout"
            style="
              position: relative;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
            "
          >
            <v-card color="#2d3a57" class="white--text" elevation="3 ">
              <v-card-text class="white--text">
                <div class="d-flex justify-space-between">
                  <img src="../images/gold-badge-48px.png" />
                  <v-spacer></v-spacer>
                  <h2 style="position: relative; top: 10px">
                    Reno Police Department
                  </h2>
                  <v-spacer></v-spacer>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <v-btn
            color="yellow darken-2"
            class="white--text ml-2 mt-2"
            @click="backtonews"
            >Back to Newsroom</v-btn
          >
          <v-btn
            color="yellow darken-2"
            class="black--text ml-2 mt-2"
            @click="print(id)"
            >Print</v-btn
          >

          <!-- <audio
            controls
            :id="'play' + release.wav_fileId.toString()"
            v-if="release.filename != ''"
            :ref="'play' + release.wav_fileId.toString()"
            :src="'https://news.renopd.com/wav/4590838-voicemail.wav'"
          ></audio> -->

          <v-btn
            v-if="release.filename != ''"
            color="yellow darken-2"
            class="blue--text ml-2 mt-2"
            @click="dialog = true"
            >Play Audio
          </v-btn>
          <div style="width: 100%" class="d-flex justify-center mt-5">
            <h2 style="text-shadow: 1px 1px 2px rgba(0, 0, 0, 1)">
              Office of Public Information
            </h2>
          </div>
          <!-- <div
            id="sub_title_layout"
            style="
              position: relative;
              top: 15%;
              width: 35%;
              margin: 0;
              padding: 0;
              margin-left: auto;
              margin-right: auto;
            "
          ></div> -->
          <div id="sub_title_layout">
            <h3 class="ml-2 pa-1 mb-1">Press Release</h3>

            <v-card color="#2d3a57" class="rounded_corners">
              <v-list-item three-line class="ml-1 mb-5">
                <v-list-item-content>
                  <h1 class="txtshdw mb-4">
                    <b> {{ release.release_title }} </b>
                  </h1>
                  <h2 class="mb-10">News Date: {{ release.news_date }}</h2>

                  <template>
                    <v-row dense>
                      <!-- Left column -->
                      <v-col cols="12" sm="6">
                        <!-- FLEXBOX BADGE WRAPPER (inside left column) -->
                        <div class="badge-flex pa-2">
                          <div
                            v-for="badge_num in release.badge_image"
                            :key="badge_num"
                            class="badge-item"
                          >
                            <img
                              v-if="getBadgeImageById(badge_num)"
                              :src="
                                'https://news.renopd.com/img/' +
                                getBadgeImageById(badge_num).filename
                              "
                              :style="{ maxWidth: badgeSize + 'px' }"
                              class="badge-img"
                            />

                            <div v-else style="color: red">
                              Missing badge ID: {{ badge_num }}
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <!-- Right column -->
                      <v-col
                        cols="12"
                        sm="6"
                        class="d-flex flex-column align-end text-right"
                      >
                        <!-- Anything you put here will be right-aligned -->
                        <p
                          style="
                            font-size: 19px;
                            font-weight: bolder;
                            color: cornflowerblue;
                            margin-right: 10px;
                          "
                        >
                          City of Reno
                        </p>
                        <p
                          style="
                            font-size: 19px;
                            font-weight: bolder;
                            color: cornflowerblue;
                            margin-right: 10px;
                          "
                        >
                          Reno Police Department
                        </p>
                        <p
                          style="
                            font-size: 19px;
                            font-weight: bolder;
                            color: white;
                            margin-right: 10px;
                          "
                        >
                          <em>{{ release.author_name }}</em>
                        </p>
                        <p
                          style="
                            font-size: 19px;
                            font-weight: bolder;
                            color: white;
                            margin-right: 10px;
                          "
                        >
                          <em>{{ release.author_title }}</em>
                        </p>
                        <p
                          style="
                            font-size: 19px;
                            font-weight: bolder;
                            color: white;
                            margin-right: 10px;
                          "
                        >
                          Media Phone: 775-430-5005
                        </p>
                        <p
                          style="
                            font-size: 19px;
                            font-weight: bolder;
                            color: white;
                            margin-right: 10px;
                          "
                        >
                          <a
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            :href="'mailto:' + release.author_email"
                            >{{ release.author_email }}</a
                          >
                        </p>
                        <p
                          style="
                            font-size: 19px;
                            font-weight: bolder;
                            color: white;
                            margin-right: 10px;
                          "
                        >
                          {{ release.release_date | longDate }}
                        </p>
                      </v-col>
                    </v-row>
                  </template>
                  <h3 v-html="release.release_text"></h3>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <div
              class="d-flex flex-row justify-center"
              v-if="release.filename_img != ''"
            >
              <img
                style="
                  max-width: 760px;
                  max-height: 500px;
                  height: auto;
                  border: 2px white solid;
                "
                :src="'https://news.renopd.com/upload/' + release.filename_img"
                alt="release image"
              />
            </div>
          </div>
        </div>
        <v-btn
          color="yellow darken-2"
          class="black--text ml-2 mt-2 mb-10"
          @click="scrolltop"
          >Back to Top</v-btn
        >
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
.badge-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.badge-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

strong {
  font-weight: 800;
  color: cornflowerblue;
}
b {
  font-weight: 800;
}
.rounded_corners {
  border-radius: 31px 31px 31px 31px;
  -webkit-border-radius: 31px 31px 31px 31px;
  -moz-border-radius: 31px 31px 31px 31px;
}

@media (min-width: 0px) {
  .ratio-4x3 {
    /* 4 : 3 */
    position: relative;
    padding-bottom: 75%; /* 3 / 4 × 100 */
    max-width: 768px;
    width: 100%;
  }

  .ratio-4x3 > * {
    position: absolute;
    inset: 0;
    max-width: 768px;
  }
  .txtshdw {
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
  }
  a {
    color: #72b2ff !important;
  }
  #sub_title_layout {
    position: relative;
    top: 20px;
    width: 98%;
    margin: auto;
    padding: 0;
  }
  #home-container {
    max-width: 768px;
    width: 100%;
    padding: 0 !important;
    margin: 0 !important;
  }
  #hero {
    width: 100% svw;
    height: 100% svh;
  }
  // .background-container-img {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 80dvh; /* One-third of the viewport height */
  //   background-image: url(../images/heroarch2.png); /* Replace with your image URL */
  //   background-size: cover; /* Cover the entire container */
  //   background-position: center; /* Center the background image */
  //   background-repeat: no-repeat; /* Prevent repeating */
  //   background-position-y: 77px;
  // }
  #home-container {
    width: 100%;
  }

  .alice {
    color: aliceblue;
  }

  .log-header .v-btn {
    background-color: #fc5c5c;
  }

  .section1 h1 {
    text-shadow: 2px 2px 4px #000000;
  }

  .training-table .v-data-table {
    border: 1px solid darkslateblue;
  }

  .training-table .v-btn__content {
    visibility: hidden !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .section1 {
    justify-content: center;
    width: 100%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .section1 {
    justify-content: flex-start;
    width: 100%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";

export default {
  name: "Viewone",
  components: {
    banner,
  },
  mixins: [bus_common],
  data() {
    return {
      dialog: false,
      release: {},
      id: this.$route.params.id,
    };
  },
  computed: {
    lst_badge_images() {
      return this.$store.state.lst_badge_images;
    },
    badgeSize() {
      const count = this.release.badge_image?.length || 1;

      // example logic:
      if (count === 1) return 200; // 1 badge → big
      if (count === 2) return 150;
      if (count === 3) return 120;
      if (count === 4) return 100;
      return 80; // 5 or more badges → small
    },
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      // let self = this;
      // this.init();
    },
    "$route.query.id": function () {
      console.log("news_releaseId: " + this.$route.query.id);
    },
  },
  filters: {
    longDate(value) {
      if (!value) return "";

      const date = new Date(value);

      // ordinal helper
      const ordinal = (n) =>
        n +
        (["th", "st", "nd", "rd"][((n % 100) - 20) % 10] ||
          ["th", "st", "nd", "rd"][n % 100] ||
          "th");

      const month = date.toLocaleString("en-US", { month: "long" });
      const day = ordinal(date.getDate());
      const year = date.getFullYear();

      return `${month} ${day}, ${year}`;
    },
    ifnone(value) {
      if (value == "01/01/1900") {
        return "None";
      } else {
        return value;
      }
    },
    ifnonestr(value) {
      if (value == "" || value == null) {
        return "None";
      } else {
        return value;
      }
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    getBadgeImageById(id) {
      // Vuex store contains objects keyed by badge_imageId
      const table = this.$store.state.lst_badge_images;

      if (!table) return null;

      // If table is an array, use find()
      if (Array.isArray(table)) {
        return table.find((b) => b.badge_imageId === id) || null;
      }

      // If table is an object keyed by id
      if (table[id]) return table[id];

      return null;
    },

    scrolltop() {
      const box = document.getElementById("vapp");
      box.scrollTop = 0;
    },
    playAudio(id) {
      console.log("id: " + id);
      let html_audio = document.getElementById(id);
      html_audio.play();
    },
    print(id) {
      this.mrbreakpoint("id");
      var fuaxid = this.prependRandomNumber(id);
      console.log("/print/?news_releaseId=" + fuaxid.toString());
      window.open("/print/?news_releaseId=" + fuaxid.toString(), "_blank");
    },
    backtonews() {
      this.$router.push("/");
    },
    getFirst200Characters: function (inputString) {
      // Check if the input string is less than or equal to 60 characters

      if (inputString.length <= 200) {
        return inputString;
      }
      // Return the first 30 characters
      return inputString.substring(0, 200);
    },
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },

    message2() {
      alert("when clicked this ");
    },
    getrelease() {
      console.log("getrelease");

      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;

      formIn.news_releaseId = parseInt(this.id);

      formIn.apiname = "getrelease";
      let self = this;
      this.$store
        .dispatch("getrelease", formIn)
        .then((data) => {
          this.show_loader(false);
          self.release = self.mno(data);
          let release = self.release;
          release.s_date = self.format_date_us(release.s_date);
          release.s_CreateDate = self.format_date_us(release.s_CreateDate);
          release.news_date = self.format_date_us(release.news_date);
          release.release_date = self.format_date_us(release.release_date);
          release.website_date = self.format_date_us(release.website_date);
          console.log("news_date: " + release.news_date);
          release.badge_image = release.badge_image.split("|").map(Number);
          // element.html_release_text = self.getFirst200Characters(
          //   element.release_text
          // );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error getrelease", msg.msg, "error", null, null);
        });
    },
    getResponsiveIframeWidth({ min = 320, max = 480, margin = 0 } = {}) {
      const viewport = Math.min(
        window.innerWidth,
        document.documentElement.clientWidth
      );
      let size = viewport - margin;
      size = Math.max(min, Math.min(size, max));
      return size;
    },
    init(self) {
      //   this.id = this.mno(this.$route.query.id);
      this.getrelease();
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
